import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd350c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "RTO PARTNERS", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive } from 'vue'
    import PageHeader from '@/components/PageHeader.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'RtoView',
  setup(__props) {

    const paragraph = [
      {
        title:'On Delivery Partnerships',
        data:'&nbsp&nbsp&nbsp1.&nbsp&nbsp&nbspCreate a new income stream for the RTO<br>&nbsp&nbsp&nbsp2.&nbsp&nbsp&nbspGEP will be able to match the Australian RTO with a reputable College partner overseas.<br>&nbsp&nbsp&nbsp3.&nbsp&nbsp&nbspGEP will manage the delivery partnership to produce expected outcomes.<br>&nbsp&nbsp&nbsp4.&nbsp&nbsp&nbspGEP will ensure that delivery is within ASQA Compliance if required<br>&nbsp&nbsp&nbsp5.&nbsp&nbsp&nbspIt reduces the cost of travels for the Australian RTO looking for delivery partners overseas.'
      },
      {
        title:'On Student Recruitment',
        data:'&nbsp&nbsp&nbsp1.&nbsp&nbsp&nbspIncrease number of International Students for RTO.<br>&nbsp&nbsp&nbsp2.&nbsp&nbsp&nbspChoose particular Qualifications to promote to targeted audience<br>&nbsp&nbsp&nbsp3.&nbsp&nbsp&nbspGEP recruits genuine students and prepares them based on eligibility required by RTO including English requirements.<br>&nbsp&nbsp&nbsp4.&nbsp&nbsp&nbspGEP assists students for accommodation, meet and greet and orientation on arrival in Australia.</p>'
      }
    ];

    const data = reactive(
      {
        paragraph:paragraph,
        rootPath:'/education',
        root:'Education',
        current:'rto partners',
        currentPath:'/rto',
        inquiryPath:'/contact/rto',
        isPara:true,
        isTable:false
      }
    );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PageHeader, { value: data }, null, 8, ["value"]),
    _hoisted_3
  ]))
}
}

})